import { render, staticRenderFns } from "./ImportantNotice.vue?vue&type=template&id=3d52de8a&scoped=true&"
import script from "./ImportantNotice.vue?vue&type=script&lang=js&"
export * from "./ImportantNotice.vue?vue&type=script&lang=js&"
import style0 from "./ImportantNotice.vue?vue&type=style&index=0&id=3d52de8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52de8a",
  null
  
)

export default component.exports